export default "varying vec4 vertex_color;\n\nvoid main(void) {\n    gl_FragColor = vertex_color;\n}\n"